"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var React = require("react");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
exports.SituationSelectNavigation = function (props) {
    var _a = react_1.useState(false), touching = _a[0], setTouching = _a[1];
    var onTouchStart = function () {
        setTouching(true);
    };
    var onTouchEnd = function () {
        setTouching(false);
    };
    var name = props.option.id === ""
        ? "選択なし"
        : props.subOption === undefined || props.subOption.id === ""
            ? props.option.name
            : props.option.name + "\uFF08" + props.subOption.name + "\uFF09";
    return (React.createElement(Navigation, { touching: touching, onClick: props.onClick, onTouchStart: onTouchStart, onTouchEnd: onTouchEnd },
        props.title,
        " ",
        name));
};
var Navigation = styled_components_1["default"].span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 8px;\n  height: 30px;\n  line-height: 30px;\n  vertical-align: middle;\n  text-decoration: underline;\n  ", ";\n  &:not(:last-child) {\n    border-right: solid 1px #aaa;\n  }\n"], ["\n  padding: 0 8px;\n  height: 30px;\n  line-height: 30px;\n  vertical-align: middle;\n  text-decoration: underline;\n  ",
    ";\n  &:not(:last-child) {\n    border-right: solid 1px #aaa;\n  }\n"])), function (props) {
    return props.touching
        ? "\n        background-color: #ccc;\n        color: #777;\n    "
        : "\n        color: #333;\n    ";
});
var templateObject_1;
